import { orderLinesListStyles } from "@insite/content-library/Components/CartLinesList";
import { css } from "styled-components";

orderLinesListStyles.wrapper = {
    css: css`
        > div[class^="sc-"] {
            border-bottom: none;
        }
        > div[class^="GridWrapper"] {
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
            padding: 30px 30px;
            border-radius: 7px;
            border: 1px solid #efefef;
            background: #fff;
        }
    `,
};
